import { RegisterLayout } from 'components/organisms/register_layout';
import React, { useEffect } from 'react';

const RegisterNew = () => {
  useEffect(() => {
    document.title = 'Cadastro Conlicitacao | Inteligência em Licitações Públicas';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Otimize seus resultados em licitações. Economize tempo e não perca nenhuma oportunidade de negócio com o governo. Cadastre-se gratuitamente.',
      );
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content =
        'Otimize seus resultados em licitações. Economize tempo e não perca nenhuma oportunidade de negócio com o governo. Cadastre-se gratuitamente.';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <div className="container-fluid bg-white">
      <RegisterLayout />
    </div>
  );
};
export default RegisterNew;
